/**
 * EmptyConversationState - Shows when all Fusion Copilot conversations have been closed
 * Provides a button to create a new conversation
 */

import React from 'react';
import { Flex, Text, Button, VStack } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import { IoSparklesSharp } from 'react-icons/io5';

interface EmptyConversationStateProps {
  onCreateConversation: () => void;
  isCreating: boolean;
}

const EmptyConversationState: React.FC<EmptyConversationStateProps> = ({
  onCreateConversation,
  isCreating,
}) => {
  return (
    <Flex
      flex="1"
      direction="column"
      align="center"
      justify="center"
      p={8}
      textAlign="center"
    >
      <VStack spacing={4}>
        <Flex
          w="64px"
          h="64px"
          borderRadius="full"
          bg="orange.50"
          align="center"
          justify="center"
          mb={2}
        >
          <IoSparklesSharp size={28} color="#F7480B" />
        </Flex>

        <Text fontSize="lg" fontWeight="600" color="gray.700">
          No active conversations
        </Text>

        <Text fontSize="sm" color="gray.500" maxW="280px">
          Start a new conversation with Fusion Copilot to get help with your marketing campaigns
        </Text>

        <Button
          leftIcon={<AddIcon boxSize={3} />}
          colorScheme="orange"
          size="md"
          onClick={onCreateConversation}
          isLoading={isCreating}
          loadingText="Creating..."
          mt={2}
        >
          Start new chat
        </Button>
      </VStack>
    </Flex>
  );
};

export default EmptyConversationState;
